import {
  useGetGraduationClassStudentsQuery,
  useGetUserByRoleQuery,
} from "graphql/__generated__/hooks";
import { useMemo } from "react";

export const useAvailableStudents = () => {
  const { data: dataStudents } = useGetUserByRoleQuery({
    variables: { role: "student" },
  });
  const { data: graduationClassStudentData } =
    useGetGraduationClassStudentsQuery();

  const availableStudents = useMemo(() => {
    if (!dataStudents || !graduationClassStudentData) return [];
    const studentsUnavailableIds =
      graduationClassStudentData.graduation_class_student.map(
        (gcs) => gcs.student_id,
      );
    return dataStudents.user.filter(
      (student) => !studentsUnavailableIds.includes(student.user_id),
    );
  }, [dataStudents, graduationClassStudentData]);
  const students = useMemo(() => dataStudents?.user || [], [dataStudents]);
  const graduationClassStudent = useMemo(
    () => graduationClassStudentData?.graduation_class_student,
    [graduationClassStudentData],
  );
  return { availableStudents, students, graduationClassStudent };
};
